import {I18n} from 'aws-amplify/utils';
import {
    Badge,
    Tooltip,
} from '@mantine/core';

import {
    delegationState,
    DnsZone,
} from '../types';

// ⚠️ THE TRI-STATE BADGE — three visually distinct outcomes, and the third is
// NOT a styled version of "not delegated".
//
// `appearsDelegated` is null when no conclusion was reached. "Appears" is
// load-bearing in the schema: this is a read of the provider's own published
// nameservers, not a live resolver query against the registrar, so a delegation
// that changed thirty seconds ago can legitimately read as null. Rendering that
// as a red "Not delegated" would report a healthy zone as broken at exactly the
// moment an operator is most likely to panic about it.
//
// Its own file because a module that also exports a hook or a constant breaks
// Fast Refresh, and this lints at --max-warnings 0.
export const DelegationBadge = ({zone}: { zone: DnsZone }) => {

    const state = delegationState(zone);

    if (state === 'DELEGATED') {
        return (
            <Badge variant={'light'} color={'green'}>
                {I18n.get('Delegated')}
            </Badge>
        );
    }

    if (state === 'NOT_DELEGATED') {
        return (
            <Tooltip
                label={I18n.get('The registrar nameservers do not appear to match this provider')}
                withArrow={true}
            >
                <Badge variant={'light'} color={'red'}>
                    {I18n.get('Not delegated')}
                </Badge>
            </Tooltip>
        );
    }

    // UNDETERMINED. Neutral on purpose — it is not a warning, it is an absence
    // of information, and colouring it red would be a claim the API never made.
    return (
        <Tooltip
            label={I18n.get('Delegation was not determined for this zone. This is not the same as "not delegated".')}
            withArrow={true}
        >
            <Badge variant={'outline'} color={'gray'}>
                {I18n.get('Not determined')}
            </Badge>
        </Tooltip>
    );
};
